<template>
    <div class="table">
        <div class="data-market-row title">
            <span>项目名称</span>
            <span>问卷份数</span>
            <span>总报酬</span>
        </div>
        <!-- 作答数据为空展示 -->
        <div v-show="!list.length" class="empty-content">
            <img :src="cdn_home_img + '/paas/empty.png'" alt />
            <span>暂未发布问卷</span>
        </div>
        <div v-show="list.length" class="data-market-row" v-for="item in list" :key="item.shortUrl">
            <span>{{ item.name }}</span>
            <span>{{ item.totalNum }}份</span>
            <span>￥{{ item.totalAward }}</span>
            <div class="home-btn"
                v-show="item.status === 2 
                || item.status === 6 
                || item.status === 7 
                || item.status === 10"
                @click="onShare(item)">
                转发
            </div>
            <div class="home-btn primary"
                v-show="item.status === 2" 
                @click="onAnswer(item)">
                作答
            </div>
        </div>
        <div class="table_base_fenye">
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                :page-size="10"
                :current-page="pageIndex"
                :total="total"
                @current-change="onChangePage">
            </el-pagination>
        </div>
        <limit-dialog 
            v-if="limitDialogShow" 
            :show.sync="limitDialogShow" 
            :is-app="isAppAnswer"
            :code-url="codeUrl">
        </limit-dialog>
        <share-dialog 
            v-if="shareDialogShow"
            :show.sync="shareDialogShow"
            :share-url="shareUrl"
            :code-url="codeUrl">
        </share-dialog>
    </div>   
</template>

<style lang="scss" scoped>
.table{
    width: 100%;
}
.empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    width: 100%;
    height: 500px;
    border-radius: 10px;
    img {
    width: 400px;
    }
    span {
    font-size: 18px;
    margin: 0 0 10px;
    color: #333;
    }
}
.data-market-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 82px;
    background: #fff;
    border-radius: 10px;
    font-size: 16px;
    padding: 0 4%;
    margin-bottom: 15px;
    span:nth-child(1){
        width: 33%;
        margin-right: 10%;
    }
    span:nth-child(2){
        width: 12.5%;
        margin-right: 4%;
    }
    span:nth-child(3){
        flex: 1;
    }
    span:nth-child(4){
        flex: 1;
        text-align: center;
    }
}
.data-market-row.title{
    height: 60px;
    margin-top: 50px;
    margin-bottom: 30px;
}
.home-btn{
    width: 66px;
    height: 40px;
    line-height: 40px;
}
.home-btn:nth-last-child(1){
    margin-left: 15px;
}
.home_dataMarket_zhuanfa_dialog{
    /deep/ .el-dialog__body {
        padding: 10px 20px 30px;
    }
    /deep/ .zhuanfa_dialog_bg{
        padding: 0 30px;
        .zhuanfa_now_title{
            padding: 15px 0;
            color: #333;
            font-weight: 650;
            font-size: 18px;
        }
        .zhuanfa_now_content{
            position: relative;
            display: flex;
            align-items: center;
            .home_zhuanfa_right_btn{
                width: 92px;
                position: absolute;
            }
            .copy_link{
                right: 0;
                top: -5px;
            }
            .download_qr{
                right: 0;
                top: 130px;
            }
        }
    }
}
.table_base_fenye{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px 0;
}
</style>

<script>
import { commonParams } from "@/config/common.js";
import { DataMarket } from '@/models/data-market'
import LimitDialog from './limit-dialog.vue'
import ShareDialog from './share-dialog.vue'
export default {
    props: {
        list: Array,
        total: Number
    },
    data(){
        return {
            pageIndex: 1,
            limitDialogShow: false,
            shareDialogShow: false,
            isAppAnswer: false,
            codeUrl: '',
            shareUrl: ''
        }
    },
    computed: {
        cdn_home_img() {
            return commonParams.CDN_HOME_IMG;
        },
    },
    components: {
        LimitDialog,
        ShareDialog
    },
    methods: {
        onChangePage(index){
            this.pageIndex = parseInt(index)
            this.$emit('init', this.pageIndex)
        },
        onAnswer(item){
            if(item.status === 10) {
                this.$alert('当前问卷正在作答人数已达到上限，请稍后再试！', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return
            }
            if(item.isLimitAnswerClient) {
                if(item.answerClient == 2) {
                    this.limitDialogShow = true
                    this.isAppAnswer = false
                    DataMarket.getForwardUrlShortUrl(item.shortUrl).then((res) => {
                        if (res.success) {
                            this.codeUrl = res.data.codeUrl
                        }
                    })
                    return
                }else if(item.answerClient == 3) {
                    this.limitDialogShow = true
                    this.isAppAnswer = true
                    return
                }
            }
            let url = '';
            if(item.thirdUrl) {
                url = item.thirdUrl;
            }else {
                url = './answer.html#/s/' + item.shortUrl + '?sourceType=1';
            }
            window.open(url);
        },
        onShare(item){
            DataMarket.getForwardUrlShortUrl(item.shortUrl).then((res) => {
                if (res.success) {
                    this.shareUrl = res.data.url
                    this.codeUrl = res.data.codeUrl
                    this.shareDialogShow = true
                }
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/data-market/table.vue